import { Fragment } from "react";
import * as Scrivito from "scrivito";
import classNames from "classnames";
import { formInputId } from "../formHelpers";

const FormFieldWrapper = ({
  widget,
  className,
  children,
  checkbox,
  selectBox,
}) => {
  const isOptional = widget.get("optional") === "yes";

  return (
    <Fragment>
      <Scrivito.ContentTag
        className={classNames(
          { mandatory: !isOptional && widget.get("label") },
          { optional: isOptional && widget.get("label") },
          { "p-0": checkbox },
          "light-header"
        )}
        tag="label"
        content={widget}
        attribute="label"
        htmlFor={formInputId(widget)}
      />
      <div
        className={classNames(className || { "input-group": !selectBox }, {
          "custom-form-widget-select": selectBox,
        })}
        name={`form-error-${widget.id()}`}
      >
        {children}
      </div>
    </Fragment>
  );
};

export default Scrivito.connect(FormFieldWrapper);
